/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Update selected value label for size options to show full variant title
function updateSizeOptionLabels() {
  const variantPickers = document.querySelectorAll('variant-picker');
  
  variantPickers.forEach(picker => {
    const options = picker.querySelectorAll('.product-form__option');
    
    options.forEach(option => {
      const optionName = option.querySelector('.product-form__option-name');
      if (!optionName) return;
      
      const selectedValueSpan = optionName.querySelector('.product-form__selected-value');
      if (!selectedValueSpan) return;
      
      // Check if this is a size option (block type)
      const isSizeOption = option.classList.contains('product-form__option--size');
      const blockSwatchList = option.querySelector('.block-swatch-list');
      if (blockSwatchList && isSizeOption) {
        const checkedInput = option.querySelector('.block-swatch__radio:checked');
        if (checkedInput) {
          // Get full value from data attribute or title attribute
          const fullTitle = checkedInput.getAttribute('data-full-value') || 
                           checkedInput.closest('.block-swatch').querySelector('label, a')?.getAttribute('title') || 
                           checkedInput.closest('.block-swatch').querySelector('label, a')?.getAttribute('data-full-value') ||
                           selectedValueSpan.textContent;
          
          if (fullTitle) {
            selectedValueSpan.textContent = fullTitle;
          }
        }
      }
    });
  });
}

// Update on variant change
document.addEventListener('variant:changed', function(event) {
  setTimeout(updateSizeOptionLabels, 50);
});

// Update on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateSizeOptionLabels);
} else {
  updateSizeOptionLabels();
}

// Update after variant picker re-renders
document.addEventListener('product:rerender', function() {
  setTimeout(updateSizeOptionLabels, 100);
});

// Also listen for change events on the inputs directly
document.addEventListener('change', function(event) {
  if (event.target.matches('.block-swatch__radio')) {
    setTimeout(updateSizeOptionLabels, 50);
  }
});

